import {createSelector} from 'reselect'

export const countRows = (selector: (state: any) => any) => createSelector(selector, state => state.crud.count)
export const listRows = (selector: (state: any) => any) => createSelector(selector, state => state.crud.rows)
export const getRow = (selector: (state: any) => any) => createSelector(selector, state => state.crud.row)
export const getListOptions = (selector: (state: any) => any) => createSelector(selector, state => state.crud.listOptions)
export const getFilters = (selector: (state: any) => any) => createSelector(selector, state => state.crud.filters)


